module.exports = __webpack_public_path__ + "img/userBarIconac.dea5e831.png";